// extracted by mini-css-extract-plugin
export var box = "Breaker-module--box--efa52";
export var breaker = "Breaker-module--breaker--d6fd0";
export var image = "Breaker-module--image--2cce9";